module.exports = __webpack_public_path__ + "static/media/Portrait-10070.4f94776d.jpg";